import 'regenerator-runtime';

import {useCallback, useState} from 'react';
import jQuery from 'jquery';
import {connect} from 'react-redux';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';

export const getClassName = (id, active, error) => classNames('tab', id, {active, error});

const getResult = async (url, form) => {
    let request;
    let response;

    const options = {
        data: new FormData(form),
        processData: false,
        contentType: false,
        method: 'POST',
    };

    try {
        request = jQuery.ajax(url, options);
    } catch (error) {
        return [null, error, null];
    }

    try {
        response = await request;
    } catch (error) {
        return [false, error, request];
    }

    return [true, response, request];
};

const BaseTab = ({id, active, action, buttonLabel, onClose, onSuccess, children, ...data}) => {
    const {waypoints, length, offset, CSRFMiddlewareToken} = data;
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = useCallback(
        async event => {
            event.preventDefault();

            if (isLoading) return null;

            setError(null);
            setLoading(true);

            const [success, result, request] = await getResult(action, event.target);

            setLoading(false);

            if (success) {
                onSuccess(result, request);
                onClose(null);
            } else {
                setError(result);
            }

            return success;
        },
        [isLoading, action, onSuccess, onClose, setError],
    );

    return (
        <form className={getClassName(id, active, error)} action={action} method="post" onSubmit={handleSubmit}>
            <input type="hidden" name="csrfmiddlewaretoken" value={CSRFMiddlewareToken} />
            <input type="hidden" name="waypoints" value={JSON.stringify(waypoints)} />
            <input type="hidden" name="length" value={length} />
            <input type="hidden" name="offset" value={offset} />
            {isFunction(children) ? children(error) : children}
            <button type="submit" disabled={isLoading}>
                {buttonLabel}
            </button>
        </form>
    );
};

const mapStateToProps = ({CSRFMiddlewareToken}) => ({CSRFMiddlewareToken});

export default connect(mapStateToProps)(BaseTab);
